import { Link } from "@reach/router";
import React, { useEffect, useRef, useState } from "react";
import tbmLogoBlanco from "../../assets/rebrand/logotipo-blanco.png";
import simboloBlanco from "../../assets/rebrand/simbolo-blanco.png";

export default function LandingOnlineNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setIsScrolled(currentScrollY > 50); // Cambia el color del fondo después de 50px de scroll

      if (currentScrollY > lastScrollY.current) {
        // Si el usuario baja, ocultamos el navbar
        setIsVisible(false);
      } else {
        // Si el usuario sube, mostramos el navbar
        setIsVisible(true);
      }

      lastScrollY.current = currentScrollY; // Actualizamos la referencia
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      id="navbar-landing-online"
      className={`navbar navbar-expand-lg navbar-light fixed-top d-none d-lg-flex shadow-none vw-100 `}
      style={{
        backgroundColor: isScrolled ? "#3A2D31" : "transparent",
        transform: isVisible ? "translateY(0)" : "translateY(-100%)",
      }}
    >
      <div className="container-fluid px-0 navbar-container d-flex justify-content-between align-items-center position-relative animate-fade-in-and-translate">
        <a className="navbar-brand p-0" href="/#landing">
        <img
            style={{ height: "50px", maxWidth: "unset", objectFit: "contain" }}
            src={simboloBlanco}
            alt="The Body Method"
          />
          <img
            style={{ width: "200px", maxWidth: "unset", objectFit: "contain" }}
            src={tbmLogoBlanco}
            alt="The Body Method"
          />
        </a>
        <button
          className="navbar-toggler bg-transparent border border-light position-absolute end-0 start-0 m-auto w-max-content"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars text-white "></i>
        </button>

        <div
          className="collapse navbar-collapse"
          style={{ width: "660px", maxWidth: "660px" }}
          id="navbarNav"
        >
          <div className="container-fluid px-0">
            <ul className="navbar-nav nav justify-content-between">
              <li
                className={`nav-item h-max-content
                `}
              >
                <a className="nav-link mt-0" href="#metodo">
                  Metodo
                </a>
              </li>
              <li className="nav-item nav-item-active h-max-content">
                <a className="nav-link mt-0 " href="#disciplinas">
                  Disciplinas
                </a>
              </li>

              <li className="nav-item h-max-content position-relative funciones-dropdown">
                <button
                  type="button"
                  className="nav-link dropdown-toggle mt-0 border-0 bg-transparent p-0 shadow-none"
                  aria-expanded="false"
                  id="funciones"
                >
                  Funciones
                </button>
                <ul
                  className="dropdown-menu funciones-menu"
                  aria-labelledby="funciones"
                  style={{
                    top: "100%",
                    left: "0",
                  }}
                >
                  <li>
                    <a href="#workout-planner" className="dropdown-item">
                      Planner
                    </a>
                  </li>
                  <li>
                    <a href="#filtros" className="dropdown-item">
                      Filtros
                    </a>
                  </li>
                  <li>
                    <a href="#favoritas" className="dropdown-item">
                      Favoritas
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item h-max-content">
                <a className="nav-link mt-0" href="#testimonios">
                  Testimonios
                </a>
              </li>
              <li className="nav-item h-max-content">
                <a className="nav-link mt-0" href="/paquetes/">
                  Paquetes
                </a>
              </li>
              <li className="nav-item h-max-content">
                <a className="nav-link mt-0" href="/rewards/">
                  Rewards
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Link
          className="btn btn-primary bold online-navbar__login-btn"
          to="/entrar"
        >
          <i className="fa fa-user"></i> <span className="ms-1">Ingresar</span>
        </Link>
      </div>
    </nav>
  );
}
